var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-plus-circle","titulo":"ADITIVOS SGF","subTitulo":"UABS","qtd":_vm.qtd,"mostrarQtd":_vm.$temAcessoView('CRED-UABS-ADIT-01') ? true : false,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Uabs_SolicitacoesAditivos' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }